import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import sortBy from 'lodash-es/sortBy'

const getDefaultState = () => {
  return {
    rtos: [],
    rto_trainers: [],
    trainers: [],
    employers: [],
    roles: [],
    studentCourses: [],
    enabledCourseData: [],
    learningActivities: [],
    signoffForms: [],
    mySignoffForms: {data: []},
    assignments: [],
    videos: [],
    units: [],
    messagesCount: 0,
    notificationsCount: 0
  };
};

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState (state, payload) { state = payload;},
    setTrainers (state, payload) {state.trainers = payload;},
    setRtos (state, payload) {state.rtos = payload;},
    setRtoTrainers (state, payload) {state.rto_trainers = payload;},
    setEmployers (state, payload) {state.employers = payload;},
    setRoles (state, payload) {state.roles = payload;},
    setStudentCourses (state, payload) {state.studentCourses = payload;},
    setEnabledCourseData (state, payload) {state.enabledCourseData = payload;},
    setLearningActivities (state, payload) {state.learningActivities = payload;},
    setAssignments (state, payload) {state.assignments = payload;},
    setSignoffForms (state, payload) {state.signoffForms = payload;},
    setMySignoffForms (state, payload) {state.mySignoffForms = payload;},
    setVideos (state, payload) {state.videos = payload;},
    setUnits (state, payload) {state.units = payload;},
    setNotificationsCount (state, payload) { state.notificationsCount = payload; },
    setMessagesCount (state, payload) { state.messagesCount = payload; }
  },
  actions: {
    RESET_STATE: function ({commit}) {
      commit('resetState', getDefaultState());
    },
    INCREMENT_NOTIFICATIONS: function ({commit, state}) {
      let notificationsCount = state.notificationsCount;
      commit('setNotificationsCount', notificationsCount + 1);
    },
    LOAD_LEARNING_ACTIVITIES: function ({commit}, v) {
      if (!this.state.learningActivities.length) {
        v.axios.get('/forms?form_type=2').then(rsp => {
          commit('setLearningActivities', rsp.data.data);
        });
      }
    },
    LOAD_ASSIGNMENTS: function ({commit}, v) {
      if (!this.state.assignments.length) {
        v.axios.get('/forms?form_type=1').then(rsp => {
          commit('setAssignments', rsp.data.data);
        });
      }
    },
    LOAD_SIGNOFF_FORMS: function ({commit}, v) {
      if (!this.state.signoffForms.length) {
        v.axios.get('/forms?form_type=3').then(rsp => {
          commit('setSignoffForms', rsp.data.data);
        });
      }
    },
    LOAD_MY_SIGNOFF_FORMS: function ({commit}, v) {
      v.axios.get('/signoff/list').then(rsp => {
        commit('setMySignoffForms', rsp.data);
      });
    },
    LOAD_VIDEOS: function ({commit}, v) {
      if (!this.state.videos.length) {
        v.axios.get('/video_library').then(rsp => {
          commit('setVideos', rsp.data);
        });
      }
    },
    LOAD_UNITS: function ({commit}, v) {
      if (!this.state.units.length) {
        v.axios.get('/courses', {params: {includes: 'codes', order_by: 'updated_at,desc'}}).then(rsp => {
          commit('setUnits', rsp.data);
        }).catch(err => this.$errorOut(err));
      }
    },
    LOAD_WORKPLACE_TRAINERS: function ({commit}, v) {
      if (!this.state.trainers.length) {
        v.axios.get('/users?role_id=5&enabled=1').then(rsp => {
          commit('setTrainers', rsp.data.data);
        });
      }
    },
    LOAD_RTOS: function ({commit}, v) {
      if (!this.state.rtos.length) {
        v.axios.get('/rtos').then(rsp => {
          commit('setRtos', rsp.data.data);
        });
      }
    },
    LOAD_ROLES: function ({commit}, v) {
      if (!this.state.roles.length) {
        v.axios.get('/roles').then(rsp => {
          commit('setRoles', rsp.data.data);
        });
      }
    },
    LOAD_RTO_TRAINERS: function ({commit}, v) {
      if (!this.state.rto_trainers.length) {
        v.axios.get('/users?role_id=14&enabled=1').then(rsp => {
          commit('setRtoTrainers', rsp.data.data);
        });
      }
    },
    LOAD_EMPLOYERS: function ({commit}, v) {
      if (!this.state.employers.length) {
        v.axios.get('/users?role_id=4&enabled=1').then(rsp => {
          commit('setEmployers', rsp.data.data);
        });
      }
    },
    LOAD_USER_COURSES: function ({commit}, v) {
      v.axios.get('/user_courses').then((rsp) => {
        let studentCourses;
        let enabledCourseData;
        if (v.$auth.check('student')) {
          studentCourses = rsp.data.data;
          enabledCourseData = [...studentCourses].map(userCourse => {
            userCourse.modulesTotal = userCourse.user_modules.length;
            userCourse.modulesPassed = 0;
            userCourse.sectionsTotal = 0;
            userCourse.sectionsPassed = 0;
            for (const userModule of userCourse.user_modules) {
              if (userModule.is_complete || userCourse.is_completed)
                userCourse.modulesPassed++;
              userCourse.sectionsTotal = userCourse.sectionsTotal + userModule.user_sections.length;
              for (const userSection of userModule.user_sections) {
                if (userSection.is_complete || userModule.is_complete || userCourse.is_completed)
                  userCourse.sectionsPassed++;
              }
            }
            userCourse.user_modules = sortBy(userCourse.user_modules, 'ordinal')
            userCourse.modulesPassedPct = Math.round(userCourse.modulesPassed / userCourse.modulesTotal * 100);
            userCourse.sectionsPassedPct = Math.round(userCourse.sectionsPassed / userCourse.sectionsTotal * 100);
            return userCourse;
          });
        } else {
          studentCourses = rsp.data.map(course => {
            course.is_enabled = true;
            course.is_completed = false;
            course.course_id = course.id;
            course.user_modules = course.modules.map(module => {
              module.is_enabled = true;
              module.is_complete = false;
              module.user_sections = module.sections.map(section => {
                section.section_id = section.id;
                return section;
              });
              return module;
            });

            course.user_modules = sortBy(course.user_modules, 'ordinal')

            return course;
          });
          enabledCourseData = studentCourses;
        }

        commit('setStudentCourses', studentCourses);
        commit('setEnabledCourseData', enabledCourseData);

      }).catch((err) => console.log(err.response));
    }
  }
});
